import * as _ from "lodash-es";
import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { isMobile } from "react-device-detect";
import IGetAllSupplierTokensDTO from "../../../../models/DTO/IGetAllSupplierTokensDTO";
import IGetCategoriesDTO from "../../../../models/DTO/IGetCategoriesDTO";
import IGetClientsDTO from "../../../../models/DTO/IGetClientsDTO";
import IGetSubCategoriesDTO from "../../../../models/DTO/IGetSubCategoriesDTO";
import IGetVendorSourceLocationItemsByCategoryDTO from "../../../../models/DTO/IGetVendorSourceLocationItemsByCategoryDTO";
import IOnGetAllSupplierTokensDTO from "../../../../models/DTO/IOnGetAllSupplierTokensDTO";
import IOnGetCategoriesDTO from "../../../../models/DTO/IOnGetCategoriesDTO";
import IOnGetClientsDTO from "../../../../models/DTO/IOnGetClientsDTO";
import IOnGetSubCategoriesDTO from "../../../../models/DTO/IOnGetSubCategoriesDTO";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import IOnGetVendorSourceLocationItemsByCategoryDTO from "../../../../models/DTO/IOnGetVendorSourceLocationItemsByCategoryDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import ICategory from "../../../../models/ICategory";
import IClient from "../../../../models/IClient";
import IOrderSearchConfig from "../../../../models/IOrderSearchConfig";
import ISupplierModel from "../../../../models/ISupplierModel";
import ISupplierSettings from "../../../../models/ISupplierSettings";
import IUserUI from "../../../../models/IUserUI";
import IVendor_Source from "../../../../models/IVendor_Source";
import IVendorModel from "../../../../models/IVendorModel";

import OrderItemTypeEnum from "../../../../models/OrderItemTypeEnum";
import OrderSearchColEnum from "../../../../models/OrderSearchColEnum";
import UIService from "../../../../services/UIService";
import ChevronToggle from "../../../shared/ChevronToggle/ChevronToggle";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import OwDateRange from "../../../shared/OwDateRange/OwDateRange";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";

import Typeahead from "../../../shared/Typeahead/Typeahead";
import "./OrderFilter.scss";
import OrderEntryService from "../../../../services/OrderEntryService";
import OrderStatesEnum from "../../../../models/OrderStatesEnum";
import IUser from "../../../../models/IUser";
import IGetVendorsDTO from "../../../../models/DTO/IGetVendorsDTO";
import ISupplierGetUsersDTO from "../../../../models/DTO/ISupplierGetUsersDTO";
import ISuppliersOnGetUsersDTO from "../../../../models/DTO/ISuppliersOnGetUsersDTO";
import UserTypesEnum from "../../../../models/UserTypesEnum";
import AccessTypesEnum from "../../../../models/AccessTypesEnum";
import SupplierGuidEnum from "../../../../models/SupplierGuidEnum";
import IWorkflow from "../../../../models/IWorkflow";
import IOnGetWorkflowsDTO from "../../../../models/DTO/IOnGetWorkflowsDTO";
import IGetWorkflowsDTO from "../../../../models/DTO/IGetWorkflowsDTO";
import { Socket } from "socket.io-client";
import { TypeaheadFn } from "../../../shared/TypeaheadFn/TypeaheadFn";
import IRoute from "../../../../models/IRoute";
import IGetRoutesDTO from "../../../../models/DTO/IGetRoutesDTO";
import IOnGetRoutesDTO from "../../../../models/DTO/IOnGetRoutesDTO";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import IGetTagsDTO from "../../../../models/DTO/IGetTagsDTO";
import IOnGetTagsDTO from "../../../../models/DTO/IOnGetTagsDTO";
import ITag from "../../../../models/ITag";
import SupplierService from "../../../../services/SupplierService";
import UserService from "../../../../services/UserService";
import ITokenSettings from "../../../../models/ITokenSettings";
import { OwMultiSelectOption } from "../../../shared/OwMultiSelectOption/OwMultiSelectOption";
import { IOption } from "../../../../models/IOption";
import { OrdersService } from "../OrdersService";

type Props = {
    socket: Socket;
    searchFn: (queryString: string, percentageFillable?: boolean, isReset?: boolean) => void;
    saveAsDefaults: (ordersFilters: { [key: string]: string | boolean }) => void;
    currentQueryStringArr: (queryString: string[]) => void;
    is_quotes: boolean;
    is_templates: boolean;
    has_quotes: boolean;
    has_templates: boolean;
    history: any;
    location: any;
    isVisible?: boolean;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    catalogs: ICatalog[];
    isActive: boolean;
};

type State = {
    foundVendors: IVendorModel[];
    clearVendorTypeahead: boolean;
    clearUserTypeahead: boolean;
    selectedVendor: IVendorModel | null;
    connectedVendors: IVendorModel[];
    dateSelectedValue: any;
    order_state_id: string;
    category_id: string;
    invoice_no: string;
    load_no: string;
    sample_no: string;
    deceased_last_name: string;
    orderStatuses?: any[];
    disableSearch: boolean;
    isConnected?: boolean;
    isOrderSearchDisabled?: boolean;
    isCarrierDisabled?: boolean;
    startDateSelectedValue?: any;
    createdAtStartDateSelectedValue?: any;
    deceasedStartDateSelectedValue?: any;
    createdAtEndDateSelectedValue?: any;
    endDateSelectedValue?: any;
    deceasedEndDateSelectedValue?: any;
    doNotShipBeforeStartDateSelectedValue?: any;
    doNotShipBeforeEndDateSelectedValue?: any;
    selectedClient?: any;
    order?: any;
    parent_order?: any;
    po_no?: string;
    catalogGuid?: string;
    clearClientTypeahead?: any;
    foundClients?: any[];
    description?: string;
    isVisible?: boolean;
    isOnline: boolean;
    filter_preliminary?: boolean;
    filter_shipped?: boolean;
    filter_cancelled?: boolean;
    filter_remakes?: boolean;
    filter_expedited?: boolean;
    filter_notes?: boolean;
    filter_only_backorder?: boolean;
    is_dropship?: boolean;
    filter_only_consignment?: boolean;
    filter_delivered?: boolean;
    filter_picked_up?: boolean;
    filter_closed?: boolean;
    filter_older_three_months?: boolean;
    filter_order_type?: "inventory" | "noninventory";
    percentage_fillable?: boolean;
    include_sub_accounts?: boolean;
    third_party_order_ref?: string;
    categories?: ICategory[];
    productTypeOptions: ICategory[];
    lmc_product_type_id?: string | null;
    lmc_offering_category_id?: string | null;
    vendor_source_id?: string | null;
    vendor_source_location_id?: string | null;
    has_accounting?: boolean | null;
    qbo_invoice_created?: boolean | null;
    qbo_invoice_emailed?: boolean | null;
    qbd_invoice_created?: boolean | null;
    qbd_sales_order_created?: boolean | null;
    fishbowl_so_id?: string;
    subCategoryOptions: ICategory[];
    foundVendorSources: IVendor_Source[];
    selectedVendorSource?: IVendor_Source;
    shipping_warehouse_id?: number | null;
    foundUsers: IUser[];
    selectedUser?: IUser | null;
    workflows: IWorkflow[];
    workflow_id?: string;
    is_local_pickup?: boolean;
    is_local_delivery?: boolean;
    has_serial_items?: boolean;
    route_id?: number;
    routes?: IRoute[];
    resetRouteTypeahead: boolean;
    tagsToFind: number[];
    foundTags: ITag[];
    selectedTags: ITag[];
    clearTagTypeahead: boolean;
    selected_order_categories?: string;
};

export class OrderFilter extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        const filter_preliminary = this.getUserDefaultSetting("filter_preliminary", false);
        const filter_shipped = this.getUserDefaultSetting("filter_shipped", this.props.is_quotes ? false : true);
        const filter_delivered = this.getUserDefaultSetting("filter_delivered", this.props.is_quotes ? false : true);
        const filter_picked_up = this.getUserDefaultSetting("filter_picked_up", this.props.is_quotes ? false : true);
        const filter_older_three_months = this.getUserDefaultSetting("filter_older_three_months", this.props.is_quotes ? false : true);
        const filter_remakes = this.getUserDefaultSetting("filter_remakes", false);
        const filter_expedited = this.getUserDefaultSetting("filter_expedited", false);
        const filter_cancelled = this.getUserDefaultSetting("filter_cancelled", false);
        const filter_closed = this.getUserDefaultSetting("filter_closed", false);
        const filter_notes = this.getUserDefaultSetting("filter_notes", false);
        const include_sub_accounts = this.getUserDefaultSetting("include_sub_accounts", false);
        const filter_only_backorder = this.getUserDefaultSetting("filter_only_backorder", false);
        const filter_order_type = this.getUserDefaultSetting("filter_order_type", undefined);

        let catalogGuid = "";

        if (this.props.supplierModel.Default_Catalog && this.props.supplierModel.has_default_order_catalog) {
            catalogGuid = this.props.supplierModel.Default_Catalog.guid;
        }

        this.state = {
            foundVendors: [],
            clearVendorTypeahead: false,
            clearUserTypeahead: false,
            selectedVendor: null,
            connectedVendors: [],
            dateSelectedValue: null,
            order_state_id: "",
            category_id: "",
            invoice_no: "",
            load_no: "",
            sample_no: "",
            deceased_last_name: "",
            catalogGuid,
            disableSearch: false,
            orderStatuses: [],
            isVisible: isMobile ? false : this.props.isVisible || true,
            isOnline: navigator.onLine,
            filter_preliminary,
            filter_shipped,
            filter_delivered,
            filter_picked_up,
            filter_remakes,
            filter_expedited,
            filter_cancelled,
            filter_closed,
            filter_older_three_months,
            categories: [],
            productTypeOptions: [],
            filter_notes,
            include_sub_accounts,
            filter_only_backorder,
            subCategoryOptions: [],
            foundVendorSources: [],
            foundUsers: [],
            selectedUser: null,
            workflows: [],
            is_local_delivery: false,
            is_local_pickup: false,
            resetRouteTypeahead: false,
            tagsToFind: [],
            foundTags: [],
            selectedTags: [],
            clearTagTypeahead: false,
            filter_order_type,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: this.onGetAllSupplierTokens },
            { endpoint: EndpointsEnum.ClientOnGetClients, fn: this.onGetClients },
            { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: this.onGetVendors },
            // Removed OrderOnGetOrders listener - using isActive prop instead
            { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: this.onGetOrderCategories },
            { endpoint: EndpointsEnum.CategoriesOnGetSubCategories, fn: this.onGetSubCategories },
            {
                endpoint: EndpointsEnum.PurchaseOrderOnGetVendorSourceLocationItemsByCategory,
                fn: this.onGetVendorSourceLocationItemsByCategory,
            },
            { endpoint: EndpointsEnum.SuppliersOnGetUsers, fn: this.onGetSupplierUsers },
            { endpoint: EndpointsEnum.WorkflowsOnGetWorkflows, fn: this.onGetWorkflows },
            { endpoint: EndpointsEnum.RoutesOnGetRoutes, fn: this.onGetRoutes },
            { endpoint: EndpointsEnum.TagsOnGetTags, fn: this.onGetTags },
        ];
    }

    async componentDidMount() {
        if (!_.isNil(this.props.socket)) {
            for (const socket of this.sockets) {
                this.props.socket.on(socket.endpoint, socket.fn);
            }

            if (this.props.userModel && this.props.userModel.isSupplierUser) {
                // this.getAllSupplierTokens();
            }

            if (this.props.supplierModel.has_order_categories) {
                this.getOrderCategories();
            }

            if (this.props.supplierModel.has_multi_workflows) {
                if (this.props.userModel.isSupplierUser) {
                    this.getWorkflows();
                }
            }

            if (this.props.supplierModel.orders_search_config) {
                for (const configItem of this.props.supplierModel.orders_search_config) {
                    if (configItem.customField === "LMC_Product_Type") {
                        this.getProductTypes();
                    }
                }
            }

            const params = new URLSearchParams(this.props.location.search);

            const order = params.get("order");

            const parent_order = params.get("parent_order");

            const vendor_name = params.get("vendor_name");
            const vendor_guid = params.get("vendor");

            let selectedVendor;

            if (vendor_name && vendor_guid) {
                selectedVendor = {
                    name: vendor_name,
                    guid: vendor_guid,
                };
            }

            const updated_at = params.get("updated_at");

            let dateSelectedValue;

            if (updated_at) {
                dateSelectedValue = moment(updated_at);
            }

            const ship_date_range_start = params.get("ship_date_range_start");
            const ship_date_range_end = params.get("ship_date_range_end");

            let startDateSelectedValue;
            let endDateSelectedValue;

            if (ship_date_range_start) {
                startDateSelectedValue = moment(ship_date_range_start);
            }

            if (ship_date_range_end) {
                endDateSelectedValue = moment(ship_date_range_end);
            }

            const deceased_start_date = params.get("deceased_start_date");
            const deceased_end_date = params.get("deceased_end_date");

            let deceasedStartDateSelectedValue;
            let deceasedEndDateSelectedValue;

            if (deceased_start_date) {
                deceasedStartDateSelectedValue = moment(deceased_start_date);
            }

            if (deceased_end_date) {
                deceasedEndDateSelectedValue = moment(deceased_end_date);
            }

            const do_not_ship_before_start_date = params.get("do_not_ship_before_start_date");
            const do_not_ship_before_end_date = params.get("do_not_ship_before_end_date");

            let doNotShipBeforeStartDateSelectedValue;
            let doNotShipBeforeEndDateSelectedValue;

            if (do_not_ship_before_start_date) {
                doNotShipBeforeStartDateSelectedValue = moment(do_not_ship_before_start_date);
            }

            if (do_not_ship_before_end_date) {
                doNotShipBeforeEndDateSelectedValue = moment(do_not_ship_before_end_date);
            }

            const catalog = params.get("catalog");

            const description = params.get("description");

            const order_state_id = params.get("order_state") || this.getUserDefaultSetting("order_state_id", null);

            const filter_preliminary = params.get("filter_preliminary") || false;

            const filter_older_three_months =
                params.get("filter_older_three_months") || this.getUserDefaultSetting("filter_older_three_months", true);

            const filter_cancelled = params.get("filter_cancelled") || false;

            const is_dropship = params.get("is_dropship") || false;

            const is_local_delivery = params.get("is_local_delivery") || false;

            const is_local_pickup = params.get("is_local_pickup") || false;

            const selected_order_categories = params.get("selected_order_categories") || undefined;

            let has_serial_items: boolean | string | undefined = params.get("has_serial_items") || undefined;

            if (has_serial_items) {
                if (has_serial_items === "1") {
                    has_serial_items = true;
                } else {
                    has_serial_items = false;
                }
            }

            const tagsToFindStr: string | undefined = params.get("tags") || undefined;

            const filter_notes = params.get("filter_notes") || false;

            const filter_order_type = params.get("filter_order_type") || undefined;

            let filter_shipped = this.state.filter_shipped;
            let filter_picked_up = this.state.filter_picked_up;
            let filter_delivered = this.state.filter_delivered;

            if (order_state_id) {
                switch (Number(order_state_id)) {
                    case OrderStatesEnum.SHIPPED:
                        filter_shipped = false;
                        break;

                    case OrderStatesEnum.PICKED_UP:
                        filter_picked_up = false;
                        break;

                    case OrderStatesEnum.DELIVERED:
                        filter_delivered = false;
                        break;
                }
            }

            const category_id = params.get("category_id");

            const lmc_product_type_id = params.get("lmc_product_type_id") || null;

            const lmc_offering_category_id = params.get("lmc_offering_category_id") || null;

            const vendor_source_id = params.get("vendor_source_id") || null;

            const vendor_source_location_id = params.get("vendor_source_location_id") || null;

            const include_sub_accounts = params.get("include_sub_accounts") || false;

            const deceased_last_name = params.get("deceased_last_name") || "";

            const qbd_invoice_created = params.get("qbd_invoice_created")
                ? params.get("qbd_invoice_created") === "true"
                : this.getUserDefaultSetting("qbo_invoice_created", null);

            const qbd_sales_order_created = params.get("qbd_sales_order_created")
                ? params.get("qbd_sales_order_created") === "true"
                : this.getUserDefaultSetting("qbd_sales_order_created", null);

            const tagsToFind = tagsToFindStr?.length ? tagsToFindStr.split(",").map(Number) : [];

            const state: any = {
                orderStatuses: this._getStatus(),
                isConnected: true,
                order,
                parent_order,
                selectedVendor,
                dateSelectedValue,
                startDateSelectedValue,
                endDateSelectedValue,
                deceasedStartDateSelectedValue,
                deceasedEndDateSelectedValue,
                doNotShipBeforeStartDateSelectedValue,
                doNotShipBeforeEndDateSelectedValue,
                description,
                filter_preliminary,
                filter_cancelled,
                filter_notes,
                include_sub_accounts,
                deceased_last_name,
                qbd_invoice_created,
                qbd_sales_order_created,
                is_dropship,
                filter_older_three_months,
                is_local_delivery,
                is_local_pickup,
                has_serial_items,
                tagsToFind,
                filter_order_type,
                selected_order_categories,
                filter_shipped,
                filter_picked_up,
                filter_delivered,
            };

            if (catalog) {
                state.catalogGuid = catalog;
            }

            if (order_state_id) {
                state.order_state_id = order_state_id;
            }

            if (category_id) {
                state.category_id = category_id;
            }

            if (lmc_product_type_id) {
                state.lmc_product_type_id = lmc_product_type_id;
            }

            if (lmc_offering_category_id) {
                state.lmc_offering_category_id = lmc_offering_category_id;
            }

            if (vendor_source_id) {
                state.vendor_source_id = vendor_source_id;
            }

            if (vendor_source_location_id) {
                state.vendor_source_location_id = vendor_source_location_id;
            }

            this.setState(state, () => {
                this.performSearch();
            });
        }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getUserDefaultSetting = (prop: string, defaultValue: any) => {
        const currentToken = UserService.getCurrentToken(this.props.userModel);

        let settingsProp: keyof ITokenSettings = "orders_filters";

        if (this.props.is_quotes) {
            settingsProp = "quotes_filters";
        }

        // @ts-expect-error
        if (currentToken?.settings && currentToken.settings[settingsProp] && !_.isNil(currentToken.settings[settingsProp][prop])) {
            // @ts-expect-error
            return currentToken.settings[settingsProp][prop];
        } else {
            return defaultValue;
        }
    };

    // Removed onGetOrders handler - button states now controlled by isActive prop from parent

    getProductTypes = () => {
        if (this.state.catalogGuid) {
            const payload: IGetCategoriesDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                onlyRootCategories: true,
                catalogGuid: this.state.catalogGuid,
            };

            if (!this.props.userModel.isSupplierUser) {
                payload.vendorGuid = this.props.vendorModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
        }
    };

    getOrderCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isOrderCategory: true,
            onlyRootCategories: true,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetOrderCategories = (data: IOnGetCategoriesDTO) => {
        if (data.isOrderCategory) {
            this.setState({
                categories: data.categories,
            });
        } else if (data.onlyRootCategories) {
            this.setState(
                {
                    productTypeOptions: data.categories,
                },
                () => {
                    if (this.state.lmc_product_type_id) {
                        this.getSubCategories();
                    }
                }
            );
        }
    };

    getWorkflows = () => {
        const payload: IGetWorkflowsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WorkflowsGetWorkflows, payload);
    };

    onGetWorkflows = (data: IOnGetWorkflowsDTO) => {
        const sortedStatus = OrderEntryService.getSortedWorkflowStatus(data.workflows);

        this.setState({
            workflows: data.workflows,
            orderStatuses: sortedStatus,
        });
    };

    limitStatusToWorkflowStatus = () => {
        const workflowId = this.state.workflow_id;

        const workflow = this.state.workflows.find((_workflow) => _workflow.id.toString() === workflowId);

        let sortedStatus: { name: string; id: number }[] = [];

        if (workflow) {
            sortedStatus = OrderEntryService.getSortedWorkflowStatus([workflow]);
        } else {
            sortedStatus = OrderEntryService.getSortedWorkflowStatus(this.state.workflows);
        }

        this.setState({
            orderStatuses: sortedStatus,
        });
    };

    getAllSupplierTokens = () => {
        const data: IGetAllSupplierTokensDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetAllSupplierTokens, data);
    };

    onGetAllSupplierTokens = (data: IOnGetAllSupplierTokensDTO) => {
        const connectedVendors = data.tokens.connectedVendors;

        this.setState({
            connectedVendors,
        });
    };

    getSubCategories = () => {
        if (this.state.lmc_product_type_id) {
            let parentCategoryGuid = "";

            for (const rootCategory of this.state.productTypeOptions) {
                if (rootCategory.id === Number(this.state.lmc_product_type_id)) {
                    parentCategoryGuid = rootCategory.guid;
                }
            }

            const payload: IGetSubCategoriesDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                parentCategoryGuid,
            };

            if (!this.props.userModel.isSupplierUser) {
                payload.vendorGuid = this.props.vendorModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.CategoriesGetSubCategories, payload);
        }
    };

    onGetSubCategories = (data: IOnGetSubCategoriesDTO) => {
        const subCategoryOptions = _.orderBy(data.categories, ["sequence"], ["asc"]);

        const state: any = {
            subCategoryOptions,
        };

        this.setState(state, () => {
            if (this.state.vendor_source_id) {
                this.getVendorSourceLocationItemsByCategory();
            }
        });
    };

    getVendorSourceLocationItemsByCategory = () => {
        if (this.state.lmc_offering_category_id) {
            let categoryGuid = "";

            for (const category of this.state.subCategoryOptions) {
                if (category.id === Number(this.state.lmc_offering_category_id)) {
                    categoryGuid = category.guid;
                }
            }

            let catalogGuid = "";

            if (this.props.catalogs.length) {
                catalogGuid = this.props.catalogs[0].guid;
            }

            const payload: IGetVendorSourceLocationItemsByCategoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid,
                categoryGuid,
                limit: 500,
            };

            if (!this.props.userModel.isSupplierUser) {
                payload.vendorGuid = this.props.vendorModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourceLocationItemsByCategory, payload);
        }
    };

    onGetVendorSourceLocationItemsByCategory = (data: IOnGetVendorSourceLocationItemsByCategoryDTO) => {
        const state: any = {};

        const foundVendorSources = _.sortBy(data.vendorSources, "name");

        state.foundVendorSources = foundVendorSources;

        if (this.state.vendor_source_id) {
            const selectedVendorSource = foundVendorSources.find((vendorSource) => {
                return vendorSource.id === Number(this.state.vendor_source_id);
            });

            state.selectedVendorSource = selectedVendorSource;
        }

        this.setState(state);
    };

    selectedUser = (user: IUser) => {
        const state: any = {
            foundUsers: null,
            selectedUser: user,
        };

        this.setState(state);
    };

    selectedVendor = (vendor: IVendorModel) => {
        // do something with the selected vendor?
        // console.log("selectedVendor: ", vendor);

        const state: any = {
            foundVendors: null,
            selectedVendor: vendor,
            isOrderSearchDisabled: false,
            isCarrierDisabled: false,
        };

        this.setState(state, () => {
            // this.getVendorOrders();
        });
    };

    findUsersByName = (typeahead: string) => {
        if (this.props.userModel && this.props.supplierModel) {
            const encodedTypeahead = encodeURIComponent(typeahead);

            const payload: ISupplierGetUsersDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                queryString: `name=${encodedTypeahead}`,
            };

            this.props.socket.emit(EndpointsEnum.SuppliersGetUsers, payload);
        }
    };

    onGetSupplierUsers = (data: ISuppliersOnGetUsersDTO) => {
        this.setState({
            foundUsers: data.users,
        });
    };

    findVendorsByName = (typeahead: string) => {
        if (this.props.userModel && this.props.supplierModel) {
            const encodedTypeahead = encodeURIComponent(typeahead);

            const payload: IGetVendorsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                queryString: `name=${encodedTypeahead}`,
            };

            this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
        }
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = data.supplierVendorTokens.map((tokenData) => {
            return tokenData.Vendor!;
        });

        this.setState({
            foundVendors,
        });
    };

    handleDateChange = (date: any) => {
        this.setState({
            dateSelectedValue: date,
        });
    };

    handleCreatedAtStartDateChange = (date: any) => {
        this.setState({
            createdAtStartDateSelectedValue: date,
        });
    };

    handleCreatedAtEndDateChange = (date: any) => {
        this.setState({
            createdAtEndDateSelectedValue: date,
        });
    };

    handleStartDateChange = (date: any) => {
        this.setState({
            startDateSelectedValue: date,
        });
    };

    handleEndDateChange = (date: any) => {
        this.setState({
            endDateSelectedValue: date,
        });
    };

    handleDoNotShipBeforeStartDateChange = (date: any) => {
        this.setState({
            doNotShipBeforeStartDateSelectedValue: date,
        });
    };

    handleDoNotShipBeforeEndDateChange = (date: any) => {
        this.setState({
            doNotShipBeforeEndDateSelectedValue: date,
        });
    };

    handleDeceasedStartDateChange = (date: any) => {
        this.setState({
            deceasedStartDateSelectedValue: date,
        });
    };

    handleDeceasedEndDateChange = (date: any) => {
        this.setState({
            deceasedEndDateSelectedValue: date,
        });
    };

    _getStatus = () => {
        const orderSteps = OrderEntryService.getOrderSteps(this.props.supplierModel, OrderStatesEnum.PRELIMINARY);
        const statusItems = orderSteps.map((stepItem) => {
            return { name: stepItem.name, id: stepItem.order_state_id };
        });

        return statusItems;
    };

    getOrderStatusById = (id: any) => {
        const statuses = this._getStatus();

        const status = _.find(statuses, (status, index) => {
            return status.id === parseInt(id);
        });

        return _.get(status, "name", "");
    };

    handleChange = (e: any) => {
        if (e.key === "enter") {
            this.performSearch();
            return;
        }

        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        if (name === "has_accounting" && value.length) {
            state.has_accounting = state.has_accounting === "true";
        }

        if (name === "qbo_invoice_created" && value.length) {
            state.qbo_invoice_created = state.qbo_invoice_created === "true";
        }

        if (name === "qbo_invoice_emailed" && value.length) {
            state.qbo_invoice_emailed = state.qbo_invoice_emailed === "true";
        }

        if (name === "qbd_invoice_created" && value.length) {
            state.qbd_invoice_created = state.qbd_invoice_created === "true";
        }

        if (name === "qbd_sales_order_created" && value.length) {
            state.qbd_sales_order_created = state.qbd_sales_order_created === "true";
        }

        if (name === "has_serial_items" && value.length) {
            state.has_serial_items = state.has_serial_items === "true";
        }

        if (name === "order_state_id") {
            state.filter_preliminary = false;

            if (Number(value) === OrderStatesEnum.SHIPPED) {
                state.filter_shipped = false;
            }

            if (Number(value) === OrderStatesEnum.PICKED_UP) {
                state.filter_picked_up = false;
            }

            if (Number(value) === OrderStatesEnum.DELIVERED) {
                state.filter_delivered = false;
            }
        }

        if (name === "vendor_source_id") {
            const selectedVendorSource = this.state.foundVendorSources.find((vendorSource) => {
                return vendorSource.id === Number(value);
            });

            state.selectedVendorSource = selectedVendorSource;
        }

        this.setState(state, () => {
            if (name === "workflow_id") {
                this.limitStatusToWorkflowStatus();
            }
        });
    };

    enterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.performSearch();
        }
    };

    getQuery = (): string[] => {
        const query: string[] = [];

        if (!_.isNil(this.state.selectedUser)) {
            query.push(`user=${this.state.selectedUser.guid}`);
        }

        if (!_.isNil(this.state.selectedVendor)) {
            query.push(`vendor=${this.state.selectedVendor.guid}`);
            query.push(`vendor_name=${encodeURIComponent(this.state.selectedVendor.name)}`);
        }

        if (!_.isNil(this.state.selectedClient)) {
            query.push(`client=${this.state.selectedClient.guid}`);
        }

        if (!_.isNil(this.state.order) && this.state.order.length) {
            query.push(`order=${encodeURIComponent(this.state.order)}`);
        }

        if (!_.isNil(this.state.parent_order) && this.state.parent_order.length) {
            query.push(`parent_order=${encodeURIComponent(this.state.parent_order)}`);
        }

        if (!_.isNil(this.state.po_no) && this.state.po_no.length) {
            query.push(`po_no=${encodeURIComponent(this.state.po_no)}`);
        }

        if (!_.isNil(this.state.description) && this.state.description.length) {
            query.push(`description=${encodeURIComponent(this.state.description)}`);
        }

        if (!_.isNil(this.state.is_dropship) && this.state.is_dropship) {
            query.push(`is_dropship=${this.state.is_dropship ? "1" : "0"}`);
        }

        if (!_.isNil(this.state.is_local_pickup) && this.state.is_local_pickup) {
            query.push(`is_local_pickup=${this.state.is_local_pickup ? "1" : "0"}`);
        }

        if (!_.isNil(this.state.is_local_delivery) && this.state.is_local_delivery) {
            query.push(`is_local_delivery=${this.state.is_local_delivery ? "1" : "0"}`);
        }

        if (!_.isNil(this.state.has_serial_items) && this.state.has_serial_items.toString().length) {
            query.push(`has_serial_items=${this.state.has_serial_items ? "1" : "0"}`);
        }

        if (!_.isNil(this.state.category_id) && this.state.category_id.length) {
            query.push(`category_id=${this.state.category_id}`);
        }

        if (!_.isNil(this.state.selected_order_categories) && this.state.selected_order_categories.length) {
            query.push(`selected_order_categories=${this.state.selected_order_categories}`);
        }

        if (!_.isNil(this.state.workflow_id) && this.state.workflow_id.length) {
            query.push(`workflow_id=${this.state.workflow_id}`);
        }

        if (!_.isNil(this.state.dateSelectedValue)) {
            if (this.state.dateSelectedValue.toString() !== "Invalid date") {
                query.push(`updated_at=${this.state.dateSelectedValue.format("YYYY-MM-DD")}`);
            }
        }

        if (!_.isNil(this.state.startDateSelectedValue) && !_.isNil(this.state.endDateSelectedValue)) {
            query.push(`ship_date_range_start=${this.state.startDateSelectedValue.format("YYYY-MM-DD")}`);
            query.push(`ship_date_range_end=${this.state.endDateSelectedValue.format("YYYY-MM-DD")}`);
        }

        if (!_.isNil(this.state.createdAtStartDateSelectedValue) && !_.isNil(this.state.createdAtEndDateSelectedValue)) {
            query.push(`created_at_range_start=${this.state.createdAtStartDateSelectedValue.format("YYYY-MM-DD")}`);
            query.push(`created_at_range_end=${this.state.createdAtEndDateSelectedValue.format("YYYY-MM-DD")}`);
        }

        if (!_.isNil(this.state.order_state_id) && this.state.order_state_id) {
            query.push(`order_state=${this.state.order_state_id}`);
        }

        if (!_.isNil(this.state.lmc_product_type_id) && this.state.lmc_product_type_id) {
            query.push(`lmc_product_type_id=${this.state.lmc_product_type_id}`);
        }

        if (!_.isNil(this.state.lmc_offering_category_id) && this.state.lmc_offering_category_id) {
            query.push(`lmc_offering_category_id=${this.state.lmc_offering_category_id}`);
        }

        if (!_.isNil(this.state.vendor_source_id) && this.state.vendor_source_id) {
            query.push(`vendor_source_id=${this.state.vendor_source_id}`);
        }

        if (!_.isNil(this.state.route_id) && this.state.route_id) {
            query.push(`route_id=${this.state.route_id}`);
        }

        if (!_.isNil(this.state.vendor_source_location_id) && this.state.vendor_source_location_id) {
            query.push(`vendor_source_location_id=${this.state.vendor_source_location_id}`);
        }

        if (!_.isNil(this.state.include_sub_accounts) && this.state.include_sub_accounts) {
            query.push(`include_sub_accounts=${this.state.include_sub_accounts}`);
        }

        if (!_.isNil(this.state.deceasedStartDateSelectedValue) && !_.isNil(this.state.deceasedEndDateSelectedValue)) {
            query.push(`deceased_start_date=${this.state.deceasedStartDateSelectedValue.format("YYYY-MM-DD")}`);
            query.push(`deceased_end_date=${this.state.deceasedEndDateSelectedValue.format("YYYY-MM-DD")}`);
        }

        if (!this.props.is_quotes) {
            if (!_.isNil(this.state.catalogGuid) && this.state.catalogGuid.length) {
                query.push(`catalog=${this.state.catalogGuid}`);
            }

            if (!_.isNil(this.state.filter_older_three_months) && this.state.filter_older_three_months) {
                query.push(`filter_older_three_months=${this.state.filter_older_three_months}`);
            }
        }

        if (!_.isNil(this.state.tagsToFind) && this.state.tagsToFind.length) {
            query.push(`tags=${this.state.tagsToFind.join(",")}`);
        }

        // Quotes are always preliminary
        if (!this.props.is_quotes) {
            if (!_.isNil(this.state.filter_preliminary) && this.state.filter_preliminary) {
                query.push(`filter_preliminary=${this.state.filter_preliminary}`);
            }

            if (!_.isNil(this.state.filter_cancelled) && this.state.filter_cancelled) {
                query.push(`filter_cancelled=${this.state.filter_cancelled}`);
            }

            if (!_.isNil(this.state.filter_shipped) && this.state.filter_shipped) {
                query.push(`filter_shipped=${this.state.filter_shipped}`);
            }

            if (!_.isNil(this.state.filter_delivered) && this.state.filter_delivered) {
                query.push(`filter_delivered=${this.state.filter_delivered}`);
            }

            if (!_.isNil(this.state.filter_picked_up) && this.state.filter_picked_up) {
                query.push(`filter_picked_up=${this.state.filter_picked_up}`);
            }

            if (!_.isNil(this.state.filter_remakes) && this.state.filter_remakes) {
                query.push(`filter_remakes=${this.state.filter_remakes}`);
            }

            if (!_.isNil(this.state.deceased_last_name) && this.state.deceased_last_name.length) {
                query.push(`deceased_last_name=${encodeURIComponent(this.state.deceased_last_name)}`);
            }

            if (!_.isNil(this.state.filter_expedited) && this.state.filter_expedited) {
                query.push(`filter_expedited=${this.state.filter_expedited}`);
            }

            if (!_.isNil(this.state.filter_notes) && this.state.filter_notes) {
                query.push(`filter_notes=${this.state.filter_notes}`);
            }

            if (!_.isNil(this.state.filter_only_backorder) && this.state.filter_only_backorder) {
                query.push(`filter_only_backorder=${this.state.filter_only_backorder}`);
            }

            if (!_.isNil(this.state.filter_only_consignment) && this.state.filter_only_consignment) {
                query.push(`filter_only_consignment=${this.state.filter_only_consignment}`);
            }

            if (!_.isNil(this.state.third_party_order_ref) && this.state.third_party_order_ref.length) {
                query.push(`third_party_order_ref=${encodeURIComponent(this.state.third_party_order_ref)}`);
            }

            if (!_.isNil(this.state.fishbowl_so_id) && this.state.fishbowl_so_id.length) {
                query.push(`fishbowl_so_id=${encodeURIComponent(this.state.fishbowl_so_id)}`);
            }

            if (!_.isNil(this.state.has_accounting) && _.isBoolean(this.state.has_accounting)) {
                query.push(`has_accounting=${this.state.has_accounting}`);
            }

            if (!_.isNil(this.state.qbo_invoice_created) && _.isBoolean(this.state.qbo_invoice_created)) {
                query.push(`qbo_invoice_created=${this.state.qbo_invoice_created}`);
            }

            if (!_.isNil(this.state.qbo_invoice_emailed) && _.isBoolean(this.state.qbo_invoice_emailed)) {
                query.push(`qbo_invoice_emailed=${this.state.qbo_invoice_emailed}`);
            }

            if (!_.isNil(this.state.qbd_invoice_created) && _.isBoolean(this.state.qbd_invoice_created)) {
                query.push(`qbd_invoice_created=${this.state.qbd_invoice_created}`);
            }

            if (!_.isNil(this.state.qbd_sales_order_created) && _.isBoolean(this.state.qbd_sales_order_created)) {
                query.push(`qbd_sales_order_created=${this.state.qbd_sales_order_created}`);
            }

            if (!_.isNil(this.state.filter_order_type)) {
                query.push(`filter_order_type=${this.state.filter_order_type}`);
            }
        } else {
            // Quotes only filters
            if (!_.isNil(this.state.filter_closed) && _.isBoolean(this.state.filter_closed)) {
                query.push(`filter_closed=${this.state.filter_closed}`);
            }
        }

        return query;
    };

    performSearch = () => {
        const query = OrdersService.getFilterQuery(this.state, this.props.is_quotes);

        let queryString = "";

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        if (this.props.is_quotes) {
            this.props.history({
                pathname: "/quotes",
                search: queryString,
            });
        } else if (this.props.is_templates) {
            this.props.history({
                pathname: "/templates",
                search: queryString,
            });
        } else {
            this.props.history({
                pathname: SupplierService.updateStringWithOrderNameOverride("/orders", this.props.supplierModel),
                search: queryString,
            });
        }

        if (this.props.is_quotes) {
            query.push(`is_quote=1`);
        } else {
            if (this.props.has_quotes) {
                query.push(`is_quote=0`);
            }
        }

        if (this.props.is_templates) {
            query.push(`is_template=1`);
        } else {
            if (this.props.has_templates) {
                query.push(`is_template=0`);
            }
        }

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        this.props.searchFn(queryString, this.state.percentage_fillable);
        this.props.currentQueryStringArr(query);
        // Button states now controlled by isActive prop from parent
    };

    resetSearch = () => {
        if (this.props.is_quotes) {
            this.props.history({ pathname: "/quotes", search: `filter_closed=true` });
        } else if (this.props.is_templates) {
            this.props.history({ pathname: "/templates" });
        } else {
            this.props.history({ pathname: SupplierService.updateStringWithOrderNameOverride("/orders", this.props.supplierModel) });
        }

        this.setState({
            // foundVendors: [],
            clearUserTypeahead: true,
            selectedUser: null,
            clearVendorTypeahead: true,
            selectedVendor: null,
            selectedClient: null,
            clearClientTypeahead: true,
            foundClients: [],
            // connectedVendors: [],
            dateSelectedValue: null,
            startDateSelectedValue: null,
            endDateSelectedValue: null,
            deceasedStartDateSelectedValue: null,
            deceasedEndDateSelectedValue: null,
            doNotShipBeforeStartDateSelectedValue: null,
            doNotShipBeforeEndDateSelectedValue: null,
            deceased_last_name: "",
            order_state_id: "",
            category_id: "",
            invoice_no: "",
            load_no: "",
            sample_no: "",
            order: "",
            parent_order: "",
            description: "",
            catalogGuid: "",
            filter_preliminary: this.getUserDefaultSetting("filter_shipped", false),
            filter_shipped: this.getUserDefaultSetting("filter_shipped", this.props.is_quotes ? false : true),
            filter_picked_up: this.getUserDefaultSetting("filter_picked_up", this.props.is_quotes ? false : true),
            filter_delivered: this.getUserDefaultSetting("filter_delivered", this.props.is_quotes ? false : true),
            filter_remakes: this.getUserDefaultSetting("filter_remakes", false),
            filter_expedited: this.getUserDefaultSetting("filter_expedited", false),
            filter_notes: this.getUserDefaultSetting("filter_notes", false),
            filter_only_backorder: this.getUserDefaultSetting("filter_only_backorder", false),
            filter_only_consignment: this.getUserDefaultSetting("filter_only_consignment", false),
            filter_order_type: this.getUserDefaultSetting("filter_order_type", undefined),
            include_sub_accounts: false,
            third_party_order_ref: "",
            lmc_product_type_id: null,
            lmc_offering_category_id: null,
            vendor_source_id: undefined,
            vendor_source_location_id: undefined,
            fishbowl_so_id: "",
            has_accounting: null,
            qbd_invoice_created: undefined,
            qbd_sales_order_created: undefined,
            filter_closed: true,
            is_dropship: false,
            filter_older_three_months: this.getUserDefaultSetting("filter_older_three_months", true),
            route_id: undefined,
            resetRouteTypeahead: true,
            tagsToFind: [],
            selectedTags: [],
            selected_order_categories: undefined,
        });

        let queryString = "";

        if (this.props.is_quotes) {
            queryString = "is_quote=1&filter_closed=true";
        } else if (this.props.is_templates) {
            queryString = `is_template=1`;
        } else {
            queryString =
                "filter_shipped=true&filter_picked_up=true&filter_delivered=true&is_quote=0&is_template=0&filter_older_three_months=1";
        }

        this.props.searchFn(queryString, undefined, true);
        this.props.currentQueryStringArr([queryString]);
    };

    saveDefault = () => {
        const defaultValues: any = {};

        const props = [
            "filter_preliminary",
            "filter_shipped",
            "filter_picked_up",
            "filter_delivered",
            "filter_older_three_months",
            "qbo_invoice_created",
            "qbd_sales_order_created",
            "order_state_id",
            "catalogGuid",
        ];

        for (const prop of props) {
            // @ts-expect-error
            defaultValues[prop] = this.state[prop];
        }

        this.props.saveAsDefaults(defaultValues);
    };

    getVendorField = () => {
        if (_.isNil(this.props.supplierModel) || this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Standard) {
            return null;
        }

        return (
            <div
                className={
                    "col-12 col-md-2 mb-md-3 " + (!_.isNil(this.props.userModel) && this.props.userModel.isSupplierUser ? "" : "d-none")
                }>
                <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={this.props.supplierModel} noBottomMargin={true} />
                <div className="position-relative">
                    <Typeahead
                        onKeyDownFn={this.enterSearch}
                        title={"customer search"}
                        className="form-control-sm"
                        clearTypeahead={this.state.clearVendorTypeahead}
                        clearTypeaheadCallback={() => {
                            this.clearTypeaheadCallback("clearVendorTypeahead");
                        }}
                        typeaheadItems={this.state.foundVendors}
                        titleProp="name"
                        subTitleProp=""
                        maxResults={25}
                        scrollableList={true}
                        placeholder=""
                        selectedItem={this.state.selectedVendor}
                        isSelectableFn={() => {
                            return true;
                        }}
                        selectedItemFn={this.selectedVendor}
                        typeaheadApiFn={this.findVendorsByName}
                    />
                </div>
            </div>
        );
    };

    getUserField = () => {
        if (_.isNil(this.props.supplierModel) || this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Standard) {
            return null;
        }

        let validUserType = false;

        if (this.props.userModel.userType?.id === UserTypesEnum.ADMIN) {
            validUserType = true;
        } else if (this.props.userModel.userType?.id === UserTypesEnum.SALES) {
            if (this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.FULL) {
                validUserType = true;
            }
        }

        if (this.props.userModel.isSupplierUser && !validUserType) {
            return null;
        }

        return (
            <div
                className={
                    "col-12 col-md-2 mb-md-3 " + (!_.isNil(this.props.userModel) && this.props.userModel.isSupplierUser ? "" : "d-none")
                }>
                <OwLabel title={"user"} />
                <div className="position-relative">
                    <Typeahead
                        onKeyDownFn={this.enterSearch}
                        title={"user search"}
                        className="form-control-sm"
                        clearTypeahead={this.state.clearUserTypeahead}
                        clearTypeaheadCallback={() => {
                            this.clearTypeaheadCallback("clearUserTypeahead");
                        }}
                        typeaheadItems={this.state.foundUsers}
                        titleProp="name"
                        subTitleProp=""
                        maxResults={25}
                        scrollableList={true}
                        placeholder=""
                        selectedItem={this.state.selectedUser}
                        isSelectableFn={() => {
                            return true;
                        }}
                        selectedItemFn={this.selectedUser}
                        typeaheadApiFn={this.findUsersByName}
                    />
                </div>
            </div>
        );
    };

    getCatalogField = () => {
        if (_.isNil(this.props.supplierModel) || this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Standard) {
            return null;
        }

        if (this.props.catalogs.length <= 1) {
            return null;
        }

        return (
            <div className={"col-12 col-md-2 mb-md-3 " + (!_.isNil(this.props.userModel) ? "" : "d-none")}>
                <OwLabel title={"catalog"} />
                <div className="position-relative">
                    <OwSelectOption
                        titleProp={"name"}
                        valueProp={"guid"}
                        fn={this.handleChange}
                        name={"catalogGuid"}
                        options={this.props.catalogs}
                        selectedOption={this.state}
                        selectedOptionProp={"catalogGuid"}
                        hasSelectedOptionProp={true}
                    />
                </div>
            </div>
        );
    };

    onGetClients = (data: IOnGetClientsDTO) => {
        this.setState({
            foundClients: data.clients,
        });
    };

    findClientsByName = (typeahead: string) => {
        if (this.props.userModel && this.props.supplierModel) {
            const data: IGetClientsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                queryString: `name=${typeahead}`,
            };

            if (this.props.vendorModel) {
                data.vendorGuid = this.props.vendorModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.ClientGetClients, data);
        }
    };

    selectedClient = (client: IClient) => {
        this.setState({
            selectedClient: client,
        });
    };

    clearTypeaheadCallback = (typeaheadProp: string) => {
        const state: any = {
            [typeaheadProp]: false,
        };

        this.setState(state);
    };

    getDescriptionField = () => {
        if (_.isNil(this.props.supplierModel) || this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Standard) {
            return null;
        }

        return (
            <div className={"col-12 col-md-2 " + (!_.isNil(this.props.userModel) ? "" : "d-none")}>
                <OwLabel title={"description"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwInputWrapper
                        title={"description search"}
                        name={"description"}
                        value={this.state.description}
                        fn={this.handleChange}
                        onKeyDownFn={this.enterSearch}
                    />
                </div>
            </div>
        );
    };

    getTags = (name: string) => {
        const payload: IGetTagsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name: name || "",
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.TagsGetTags, payload);
    };

    onGetTags = (data: IOnGetTagsDTO) => {
        this.setState({
            foundTags: data.tags,
        });
    };

    selectedTag = (tag: ITag) => {
        const selectedTags = this.state.selectedTags;

        if (!_.find(selectedTags, { id: tag.id })) {
            selectedTags.push(tag);
        }

        const tagsToFind = selectedTags.map((tag: ITag) => tag.id);

        this.setState({
            tagsToFind,
            selectedTags,
            clearTagTypeahead: true,
        });
    };

    clearTagTypeaheadFn = () => {
        this.setState({
            foundTags: [],
            clearTagTypeahead: false,
        });
    };

    removeTag = (tag: ITag) => {
        const selectedTags = this.state.selectedTags.filter((selectedTag: ITag) => selectedTag.id !== tag.id);
        const tagsToFind = selectedTags.map((tag: ITag) => tag.id);

        this.setState({
            selectedTags,
            tagsToFind,
        });
    };

    getTagsField = () => {
        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            return null;
        }

        return (
            <div className={"col-12 col-md-2 " + (!_.isNil(this.props.userModel) ? "" : "d-none")}>
                <OwLabel title={"tags"} noBottomMargin={true} />
                <div className="position-relative">
                    <Typeahead
                        titleProp={"name"}
                        isSelectableFn={() => true}
                        typeaheadApiFn={this.getTags}
                        selectedItemFn={this.selectedTag}
                        clearTypeahead={this.state.clearTagTypeahead}
                        clearTypeaheadCallback={this.clearTagTypeaheadFn}
                        typeaheadItems={this.state.foundTags}
                        scrollableList={true}
                    />
                </div>
                <div>
                    {this.state.selectedTags.map((tag: ITag) => {
                        return (
                            <span key={tag.guid} className={"badge bg-primary me-2"}>
                                {tag.name}{" "}
                                <i
                                    className={"fas fa-times ms-2 pointer"}
                                    onClick={() => {
                                        this.removeTag(tag);
                                    }}
                                />
                            </span>
                        );
                    })}
                </div>
            </div>
        );
    };

    getClientField = () => {
        if (this.props.supplierModel) {
            if (!this.props.supplierModel.has_client_module) {
                if (this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Nuts) {
                    return null;
                }
            }
        }

        if (!this.props.userModel || !this.props.userModel.isSupplierUser) {
            return null;
        }

        return (
            <div className={"col-12 col-md-2"}>
                <OwLabel title={"client"} noBottomMargin={true} />
                <div className="position-relative">
                    <Typeahead
                        onKeyDownFn={this.enterSearch}
                        title={"client search"}
                        className="form-control-sm"
                        clearTypeahead={this.state.clearClientTypeahead}
                        clearTypeaheadCallback={() => {
                            this.clearTypeaheadCallback("clearClientTypeahead");
                        }}
                        typeaheadItems={this.state.foundClients}
                        titleProp="name"
                        subTitleProp=""
                        maxResults={5}
                        placeholder=""
                        selectedItem={this.state.selectedClient}
                        isSelectableFn={() => {
                            return true;
                        }}
                        selectedItemFn={this.selectedClient}
                        typeaheadApiFn={this.findClientsByName}
                    />
                </div>
            </div>
        );
    };

    getWorkflowField = () => {
        if (!this.props.supplierModel.has_multi_workflows) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.id !== UserTypesEnum.ADMIN) {
            return null;
        }

        return (
            <div className="col-12 col-md-auto mb-2 mb-md-0">
                <OwLabel title={"workflow"} noBottomMargin={true} />
                <div className={"col-12 col-md-auto .g-0"}>
                    <OwSelectOption
                        title={"workflow"}
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"workflow_id"}
                        fn={this.handleChange}
                        options={this.state.workflows}
                        selectedOption={this.state}
                        selectedOptionProp={"workflow_id"}
                        translateTitle={false}
                        showBlankFirst={true}
                    />
                </div>
            </div>
        );
    };

    getStatusField = () => {
        if (this.props.is_quotes || this.props.is_templates) {
            return null;
        }

        if (_.isNil(this.props.supplierModel) || this.props.supplierModel.order_item_type_id !== OrderItemTypeEnum.Standard) {
            return null;
        }

        if (!this.state.orderStatuses) {
            return null;
        }

        return (
            <div className="col-12 col-md-auto mb-2 mb-md-0">
                <OwLabel title={"status"} noBottomMargin={true} />
                <div className={"col-12 col-md-auto .g-0"}>
                    <OwSelectOption
                        title={"order status"}
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"order_state_id"}
                        fn={this.handleChange}
                        options={this.state.orderStatuses}
                        selectedOption={this.state}
                        selectedOptionProp={"order_state_id"}
                        translateTitle={true}
                        showBlankFirst={true}
                    />
                </div>
            </div>
        );
    };

    getDeceasedDateRangeField = () => {
        if (this.props.is_quotes) {
            return null;
        }

        if (this.props.supplierModel && _.isNil(this.props.supplierModel.settings)) {
            return;
        }

        if (!this.props.supplierModel) {
            return;
        }

        const settings: ISupplierSettings = JSON.parse(JSON.stringify(this.props.supplierModel.settings));

        if (!settings.order_details) {
            return null;
        } else {
            let hasDeceasedDate = false;

            for (const detail of settings.order_details) {
                if (detail === "deceased_date") {
                    hasDeceasedDate = true;
                }
            }

            if (!hasDeceasedDate) {
                return null;
            }
        }

        return (
            <div className={"col-12 col-md-auto"}>
                <OwLabel title={"deceased_date_range"} noBottomMargin={true} />

                <div>
                    <OwDateRange
                        startDateTitle={"Stard Date"}
                        endDateTitle={"End Date"}
                        startDateSelected={this.state.deceasedStartDateSelectedValue}
                        endDateSelected={this.state.deceasedEndDateSelectedValue}
                        startFn={this.handleDeceasedStartDateChange}
                        endFn={this.handleDeceasedEndDateChange}
                    />
                </div>
            </div>
        );
    };

    getDeceasedLastNameField = () => {
        if (this.props.is_quotes) {
            return null;
        }

        if (this.props.supplierModel && _.isNil(this.props.supplierModel.settings)) {
            return;
        }

        if (!this.props.supplierModel) {
            return;
        }

        const settings: ISupplierSettings = JSON.parse(JSON.stringify(this.props.supplierModel.settings));

        if (!settings.order_details) {
            return null;
        } else {
            let hasDeceasedLastName = false;

            for (const detail of settings.order_details) {
                if (detail === "deceased_last_name") {
                    hasDeceasedLastName = true;
                }
            }

            if (!hasDeceasedLastName) {
                return null;
            }
        }

        return (
            <div className={"col-12 col-md-auto"}>
                <OwLabel title={"deceased_last_name"} />

                <div className="position-relative">
                    <OwInputWrapper
                        title={"deceased_last_name"}
                        name={"deceased_last_name"}
                        value={this.state.deceased_last_name}
                        fn={this.handleChange}
                        onKeyDownFn={this.enterSearch}
                    />
                </div>
            </div>
        );
    };

    getCreatedAtDateRange = () => {
        return (
            <div className={"col-12 col-md-auto"}>
                <OwLabel title={"created_at_date_range"} noBottomMargin={true} />

                <div>
                    <OwDateRange
                        startDateTitle={"Created At Start Date"}
                        endDateTitle={"Created At End Date"}
                        startDateSelected={this.state.createdAtStartDateSelectedValue}
                        endDateSelected={this.state.createdAtEndDateSelectedValue}
                        startFn={this.handleCreatedAtStartDateChange}
                        endFn={this.handleCreatedAtEndDateChange}
                    />
                </div>
            </div>
        );
    };

    getShipDateRange = () => {
        if (!this.props.supplierModel) {
            return;
        }

        if (this.props.is_quotes) {
            return null;
        }

        if (
            (this.props.supplierModel.has_lead_times && this.props.supplierModel.shipping_lead_time) ||
            this.props.supplierModel.has_est_ship_date
        ) {
            return (
                <div className={"col-12 col-md-auto"}>
                    <OwLabel title={"ship_date_range"} noBottomMargin={true} />

                    <div>
                        <OwDateRange
                            startDateTitle={"Ship Start Date"}
                            endDateTitle={"End Date Title"}
                            startDateSelected={this.state.startDateSelectedValue}
                            endDateSelected={this.state.endDateSelectedValue}
                            startFn={this.handleStartDateChange}
                            endFn={this.handleEndDateChange}
                        />
                    </div>
                </div>
            );
        } else {
            return;
        }
    };

    getDoNotShipBeforeDateRange = () => {
        if (!this.props.supplierModel) {
            return;
        }

        if (this.props.is_quotes) {
            return null;
        }

        if (this.props.supplierModel.has_do_not_ship_before_date) {
            return (
                <div className={"col-12 col-md-auto"}>
                    <OwLabel title={"do_not_ship_before_date_range"} noBottomMargin={true} />

                    <div>
                        <OwDateRange
                            startDateTitle={"Do Not Ship Before Start Date"}
                            endDateTitle={"Do Not Ship Before End Date"}
                            startDateSelected={this.state.doNotShipBeforeStartDateSelectedValue}
                            endDateSelected={this.state.doNotShipBeforeEndDateSelectedValue}
                            startFn={this.handleDoNotShipBeforeStartDateChange}
                            endFn={this.handleDoNotShipBeforeEndDateChange}
                        />
                    </div>
                </div>
            );
        } else {
            return;
        }
    };

    toggleVisible = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        });
    };

    getFilterOlderThreeMonths = () => {
        return (
            <OwCheckbox
                className={"ms-2"}
                label={"older_three_months"}
                name={"filter_older_three_months"}
                checked={this.state.filter_older_three_months}
                fn={this.handleChange}
                truthyVal={true}
                falsyVal={false}
            />
        );
    };

    getFilterPreliminaryField = () => {
        if (this.props.is_quotes || this.props.is_templates) {
            return null;
        }

        let showPrelim = true;
        let showShipped = true;

        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            showPrelim = false;
            showShipped = false;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <fieldset className={"d-inline-block border p-2 me-1"}>
                    <legend className={"mb-0 w-auto"}>
                        <OwLabel className={"ps-1 pe-1 text-small"} title={"filter_out"} noBottomMargin={true} />
                    </legend>
                    {showPrelim ? (
                        <OwCheckbox
                            label={"preliminary"}
                            name={"filter_preliminary"}
                            checked={this.state.filter_preliminary}
                            fn={this.handleChange}
                        />
                    ) : null}
                    {showShipped ? (
                        <OwCheckbox
                            className={"ms-2"}
                            label={"shipped"}
                            name={"filter_shipped"}
                            checked={this.state.filter_shipped}
                            fn={this.handleChange}
                        />
                    ) : null}
                    {this.props.supplierModel.has_local_pickup ? (
                        <OwCheckbox
                            className={"ms-2"}
                            label={"picked_up"}
                            name={"filter_picked_up"}
                            checked={this.state.filter_picked_up}
                            fn={this.handleChange}
                        />
                    ) : null}
                    {this.props.supplierModel.has_local_delivery ? (
                        <OwCheckbox
                            className={"ms-2"}
                            label={"delivered"}
                            name={"filter_delivered"}
                            checked={this.state.filter_delivered}
                            fn={this.handleChange}
                        />
                    ) : null}
                    {this.props.supplierModel.has_remakes && this.props.userModel.isSupplierUser ? (
                        <OwCheckbox
                            className={"ms-2"}
                            label={"cancelled"}
                            name={"filter_cancelled"}
                            checked={this.state.filter_cancelled}
                            fn={this.handleChange}
                        />
                    ) : null}
                    {this.getFilterOlderThreeMonths()}
                </fieldset>
            </div>
        );
    };

    getFilterQuoteStatusField = () => {
        if (!this.props.is_quotes) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <fieldset className={"d-inline-block border p-2 me-1"}>
                    <legend className={"mb-0 w-auto"}>
                        <OwLabel className={"ps-1 pe-1 text-small"} title={"filter"} noBottomMargin={true} />
                    </legend>
                    <OwCheckbox label={"closed"} name={"filter_closed"} checked={this.state.filter_closed} fn={this.handleChange} />
                </fieldset>
            </div>
        );
    };

    getRemakeField = () => {
        if (!this.props.supplierModel.has_remakes) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"remakes"}
                    name={"filter_remakes"}
                    checked={this.state.filter_remakes}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getFilterNotesField = () => {
        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"has_note"}
                    name={"filter_notes"}
                    checked={this.state.filter_notes}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getIsLocalPickup = () => {
        if (!this.props.supplierModel.has_local_pickup) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"local_pickup"}
                    name={"is_local_pickup"}
                    checked={this.state.is_local_pickup}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getIsLocalDelivery = () => {
        if (!this.props.supplierModel.has_local_delivery) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"local_delivery"}
                    name={"is_local_delivery"}
                    checked={this.state.is_local_delivery}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getHasSerialItems = () => {
        if (!this.props.supplierModel.has_serials) {
            return null;
        }

        const options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <div>
                    <OwLabel title={"has_serial_items"} />
                </div>
                <div>
                    <OwSelectOption
                        showBlankFirst={true}
                        options={options}
                        name={"has_serial_items"}
                        valueProp={"value"}
                        titleProp={"title"}
                        fn={this.handleChange}
                        selectedOption={this.state}
                        selectedOptionProp={"has_serial_items"}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getIncludeSubAccountsField = () => {
        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"include_sub_accounts"}
                    name={"include_sub_accounts"}
                    checked={this.state.include_sub_accounts}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                    disabled={!this.state.selectedVendor}
                />
            </div>
        );
    };

    getFilterBackorders = () => {
        if (this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (this.props.supplierModel.has_backorders) {
            return (
                <div className={"col-12 col-md-auto d-flex align-items-center"}>
                    <OwCheckbox
                        label={"is_backorder"}
                        name={"filter_only_backorder"}
                        checked={this.state.filter_only_backorder}
                        fn={this.handleChange}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    getFilterOrderType = () => {
        if (this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (this.props.supplierModel.has_noninventory_orders) {
            const options = [
                { value: "inventory", title: "inventory" },
                { value: "noninventory", title: "noninventory" },
            ];

            return (
                <div className={"col-12 col-md-auto align-items-center"}>
                    <div>
                        <OwLabel title={"order_type"} />
                    </div>
                    <div>
                        <OwSelectOption
                            showBlankFirst={true}
                            options={options}
                            name={"filter_order_type"}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"filter_order_type"}
                            translateTitle={true}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    getFilterDropshipping = () => {
        if (this.props.supplierModel.has_dropshipping) {
            return (
                <div className={"col-12 col-md-auto d-flex align-items-center"}>
                    <OwCheckbox
                        label={"is_dropship"}
                        name={"is_dropship"}
                        checked={this.state.is_dropship}
                        fn={this.handleChange}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    getFilterConsignment = () => {
        if (this.props.supplierModel.has_consignment) {
            return (
                <div className={"col-12 col-md-auto d-flex align-items-center"}>
                    <OwCheckbox
                        label={"is_consignment"}
                        name={"filter_only_consignment"}
                        checked={this.state.filter_only_consignment}
                        fn={this.handleChange}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    getExpeditedField = () => {
        if (!this.props.supplierModel.has_expedited && !this.props.supplierModel.has_service_levels) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"expedited"}
                    name={"filter_expedited"}
                    checked={this.state.filter_expedited}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getPercentageFillable = () => {
        if (!this.props.userModel.isSupplierUser || !this.props.supplierModel.has_percent_fillable) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto d-flex align-items-center"}>
                <OwCheckbox
                    label={"percent_fillable"}
                    name={"percentage_fillable"}
                    checked={this.state.percentage_fillable}
                    fn={this.handleChange}
                    truthyVal={true}
                    falsyVal={false}
                />
            </div>
        );
    };

    getThirdPartyOrderRefField = () => {
        if (!this.props.supplierModel.has_third_party_order_ref) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <OwLabel title={"third_party_order_ref"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwInputWrapper
                        title={"third_party_order_ref"}
                        name={"third_party_order_ref"}
                        value={this.state.third_party_order_ref}
                        fn={this.handleChange}
                        onKeyDownFn={this.enterSearch}
                    />
                </div>
            </div>
        );
    };

    handleOrderCategoryChange = (selected: string[]) => {
        console.log("handleOrderCategoryChange: selected_order_categories: ", selected);

        this.setState({
            selected_order_categories: selected.join(","),
        });
    };

    getOrderCategoryField = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.has_order_categories) {
            return null;
        }

        const options: IOption[] = (this.state.categories || []).map((category) => {
            const option: IOption = {
                value: category.id.toString(),
                label: category.name,
            };

            return option;
        });

        return (
            <div className={"col-12 col-md align-items-center no-wrap"}>
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "order_category"} noBottomMargin={true} />
                <OwMultiSelectOption
                    options={options}
                    onChange={this.handleOrderCategoryChange}
                    maxDisplay={1}
                    selectedOptions={this.state.selected_order_categories?.split(",")}
                />
            </div>
        );
    };

    lookupRoute = (name: string) => {
        const payload: IGetRoutesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RoutesGetRoutes, payload);
    };

    onGetRoutes = (data: IOnGetRoutesDTO) => {
        this.setState({
            routes: data.routes,
        });
    };

    selectRoute = (route: IRoute) => {
        this.setState({
            route_id: route.id,
        });
    };

    getOrderRouteField = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.has_routes) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "order_route"} noBottomMargin={true} />
                <div className="position-relative">
                    <TypeaheadFn
                        lookupFn={this.lookupRoute}
                        availableOptions={this.state.routes || []}
                        selectedOptionFn={this.selectRoute}
                        titleProp={"name"}
                        valueProp={"id"}
                        emitSelectionSetup={{ emitObject: true }}
                        resetTypeahead={this.state.resetRouteTypeahead}
                        resetTypeaheadCallbackFn={() => {
                            this.setState({
                                resetRouteTypeahead: false,
                            });
                        }}
                    />
                </div>
            </div>
        );
    };

    getHasAccountingField = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.has_accounting) {
            return null;
        }

        const accounting_options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "has_accounting"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwSelectOption
                        name={"has_accounting"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        options={accounting_options}
                        selectedOption={this.state}
                        selectedOptionProp={"has_accounting"}
                        showBlankFirst={true}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getQboInvoiceCreated = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo || this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        const options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "invoice_created"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwSelectOption
                        name={"qbo_invoice_created"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        options={options}
                        selectedOption={this.state}
                        selectedOptionProp={"qbo_invoice_created"}
                        showBlankFirst={true}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getQboInvoiceEmailed = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo || this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        const options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "invoice_emailed"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwSelectOption
                        name={"qbo_invoice_emailed"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        options={options}
                        selectedOption={this.state}
                        selectedOptionProp={"qbo_invoice_emailed"}
                        showBlankFirst={true}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getLastUpdatedField = () => {
        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        return (
            <div className="col-12 col-md-auto">
                <OwLabel title={"last_updated"} noBottomMargin={true} />
                <OwDateInput selectedDate={this.state.dateSelectedValue} fn={this.handleDateChange} />
            </div>
        );
    };

    getQbdInvoiceCreated = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbd || this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        const options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                {this.state.qbd_invoice_created}
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "invoice_created"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwSelectOption
                        name={"qbd_invoice_created"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        options={options}
                        selectedOption={this.state.qbd_invoice_created}
                        hasSelectedOptionProp={false}
                        showBlankFirst={true}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getQbdSalesOrderCreated = (configItem?: IOrderSearchConfig) => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbd || this.props.is_templates || this.props.is_quotes) {
            return null;
        }

        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        const options = [
            { value: true, title: "true" },
            { value: false, title: "false" },
        ];

        return (
            <div className={"col-12 col-md-auto align-items-center"}>
                {this.state.qbd_sales_order_created}
                <OwLabel title={configItem?.titleOverride ? configItem.titleOverride : "sales_order_created"} noBottomMargin={true} />
                <div className="position-relative">
                    <OwSelectOption
                        name={"qbd_sales_order_created"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        options={options}
                        selectedOption={this.state.qbd_sales_order_created}
                        hasSelectedOptionProp={false}
                        showBlankFirst={true}
                        translateTitle={true}
                    />
                </div>
            </div>
        );
    };

    getOrderNameSearchField = () => {
        let orderLabel = (
            <OwLabel title={SupplierService.updateStringWithOrderNameOverride("order", this.props.supplierModel)} noBottomMargin={true} />
        );

        if (this.props.is_quotes) {
            orderLabel = <OwLabel title={"quote"} noBottomMargin={true} />;
        } else if (this.props.is_templates) {
            orderLabel = <OwLabel title={"template"} noBottomMargin={true} />;
        }

        return (
            <div className="col-12 col-md-2">
                {orderLabel}
                <OwInputWrapper
                    title={"Order Name Search"}
                    name={"order"}
                    value={this.state.order}
                    fn={this.handleChange}
                    onKeyDownFn={this.enterSearch}
                />
            </div>
        );
    };

    getParentOrderNameSearchField = () => {
        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            return null;
        }

        const orderLabel = (
            <OwLabel
                title={SupplierService.updateStringWithOrderNameOverride("parent_order", this.props.supplierModel)}
                noBottomMargin={true}
            />
        );

        if (this.props.is_quotes || this.props.is_templates) {
            return null;
        }

        return (
            <div className="col-12 col-md-2">
                {orderLabel}
                <OwInputWrapper
                    title={"Parent Order Name Search"}
                    name={"parent_order"}
                    value={this.state.parent_order}
                    fn={this.handleChange}
                    onKeyDownFn={this.enterSearch}
                />
            </div>
        );
    };

    getPONumberSearchField = () => {
        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            return null;
        }

        return (
            <div className="col-12 col-md-2">
                <OwLabel title={"po_no"} noBottomMargin={true} />
                <OwInputWrapper
                    title={"PO No. Search"}
                    name={"po_no"}
                    value={this.state.po_no}
                    fn={this.handleChange}
                    onKeyDownFn={this.enterSearch}
                />
            </div>
        );
    };

    getFishbowlSOSearchField = () => {
        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        if (this.props.supplierModel.Supplier_Integration.has_fishbowl) {
            return (
                <div className="col-12 col-md-2">
                    <OwLabel title={"fishbowl_so"} noBottomMargin={true} />
                    <OwInputWrapper
                        title={"Fishbowl SO No. Search"}
                        name={"fishbowl_so_id"}
                        value={this.state.fishbowl_so_id}
                        fn={this.handleChange}
                        onKeyDownFn={this.enterSearch}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    getButtons = () => {
        return (
            <div className={"col-12 col-md-auto d-flex align-items-end d-print-none mt-2 mt-md-0"} style={{ marginBottom: "1rem" }}>
                <div>
                    <OwLabel title={""} noBottomMargin={true} />
                </div>
                <div>
                    <OwButton
                        active={this.props.isActive}
                        disableOnActive={true}
                        leftIconClass=""
                        className="btn-primary"
                        title="search"
                        fn={this.performSearch}
                    />

                    <OwButton
                        title={"reset"}
                        fn={this.resetSearch}
                        className={"btn-danger ms-2"}
                        active={this.props.isActive}
                        disableOnActive={true}
                    />

                    {this.props.is_quotes ? null : (
                        <OwButton
                            title={"save"}
                            fn={this.saveDefault}
                            className={"btn-success ms-2"}
                            active={this.props.isActive}
                            disableOnActive={true}
                        />
                    )}
                </div>
            </div>
        );
    };

    defaultOrderSearch = () => {
        return (
            <div className="row mb-2">
                {this.getCatalogField()}

                {this.getUserField()}

                {this.getVendorField()}

                {this.getClientField()}

                {this.getOrderNameSearchField()}

                {this.getParentOrderNameSearchField()}

                {this.getPONumberSearchField()}

                {this.getFishbowlSOSearchField()}

                {this.getDescriptionField()}

                {this.getShipDateRange()}

                {this.getDoNotShipBeforeDateRange()}

                {this.getCreatedAtDateRange()}

                {this.getLastUpdatedField()}

                {this.getWorkflowField()}

                {this.getStatusField()}

                {this.getHasSerialItems()}

                {this.getDeceasedDateRangeField()}

                {this.getDeceasedLastNameField()}

                {this.getHasAccountingField()}

                {this.getFilterPreliminaryField()}

                {this.getFilterQuoteStatusField()}

                {this.getFilterNotesField()}

                {this.getIsLocalDelivery()}

                {this.getIsLocalPickup()}

                {this.getIncludeSubAccountsField()}

                {this.getFilterBackorders()}

                {this.getFilterDropshipping()}

                {this.getFilterConsignment()}

                {this.getRemakeField()}

                {this.getExpeditedField()}

                {this.getPercentageFillable()}

                {this.getThirdPartyOrderRefField()}

                {this.getFilterOrderType()}

                {this.getOrderCategoryField()}

                {this.getOrderRouteField()}

                {this.getQboInvoiceCreated()}

                {this.getTagsField()}

                {this.getQboInvoiceEmailed()}

                {this.getQbdSalesOrderCreated()}

                {this.getQbdInvoiceCreated()}

                {this.getButtons()}
            </div>
        );
    };

    getCustomOrderSearchField = (configItem: IOrderSearchConfig) => {
        // For Future Custom Search Fields
        return <></>;
    };

    getCustomOrderSearch = () => {
        let hasFilterFields = false;

        return (
            <div className="row mb-2">
                {this.props.supplierModel.orders_search_config!.map((configItem) => {
                    switch (configItem.searchCol) {
                        case OrderSearchColEnum.CATALOG:
                            return this.getCatalogField();

                        case OrderSearchColEnum.VENDOR:
                            return this.getVendorField();

                        case OrderSearchColEnum.DESCRIPTION:
                            return this.getDescriptionField();

                        case OrderSearchColEnum.CLIENT:
                            return this.getClientField();

                        case OrderSearchColEnum.EXPEDITED:
                            return this.getExpeditedField();

                        case OrderSearchColEnum.FILTER_PRELIMINARY:
                            return this.getFilterPreliminaryField();

                        case OrderSearchColEnum.LAST_UPDATED:
                            return this.getLastUpdatedField();

                        case OrderSearchColEnum.ORDER:
                            return this.getOrderNameSearchField();

                        case OrderSearchColEnum.ORDER_CATEGORY:
                            return this.getOrderCategoryField(configItem);

                        case OrderSearchColEnum.PERCENTAGE_FILLABLE:
                            return this.getPercentageFillable();

                        case OrderSearchColEnum.PO:
                            return this.getPONumberSearchField();

                        case OrderSearchColEnum.REMAKE:
                            return this.getRemakeField();

                        case OrderSearchColEnum.SHIP_DATE_RANGE:
                            return this.getShipDateRange();

                        case OrderSearchColEnum.QBO_INVOICE_CREATED:
                            return this.getQboInvoiceCreated();

                        case OrderSearchColEnum.QBO_INVOICE_EMAILED:
                            return this.getQboInvoiceEmailed();

                        case OrderSearchColEnum.STATUS:
                            return this.getStatusField();

                        case OrderSearchColEnum.THIRD_PARTY_ORDER_REF:
                            return this.getThirdPartyOrderRefField();

                        case OrderSearchColEnum.ACCOUNTING:
                            return this.getHasAccountingField();

                        case OrderSearchColEnum.OLDER_THREE_MONTHS:
                            // part of the filterfield group
                            hasFilterFields = true;
                            return;
                        // return this.getFilterOlderThreeMonths();

                        case OrderSearchColEnum.CUSTOM:
                            return this.getCustomOrderSearchField(configItem);
                    }
                })}

                {hasFilterFields ? (
                    <fieldset className={"d-inline-block border p-2 me-1"}>
                        <legend className={"mb-0 w-auto"}>
                            <OwLabel className={"ps-1 pe-1 text-small"} title={"filter"} noBottomMargin={true} />
                        </legend>
                        {this.props.supplierModel.orders_search_config!.map((configItem) => {
                            switch (configItem.searchCol) {
                                case OrderSearchColEnum.OLDER_THREE_MONTHS:
                                    return this.getFilterOlderThreeMonths();
                            }
                        })}
                    </fieldset>
                ) : null}

                {this.getButtons()}
            </div>
        );
    };

    render() {
        return this.props.supplierModel.orders_search_config ? this.getCustomOrderSearch() : this.defaultOrderSearch();
    }
}

export default OrderFilter;
